import { IChainStore, IChannel, IShop } from './shop'
// import { IUser } from './user'

export type ReceiptType =
  | 'unchecked'
  | 'linkerChecked'
  | 'leaderChecked'
  | 'uncheckedSystemNg'
  | 'newItem'
  | 'reItem'
  | 'systemNg'
  | 'systemOk'
  | 'linkerNg'
  | 'leaderNg'
  | 'shopUnchecked'

export type ItemType = 'new' | 're'

export enum NgReason {
  NO_PHONE = '電話番号判読NG',
  NO_SHOP = 'チェーン名判読NG',
  NOT_FOUND_SHOP = 'チェーン店マスタなし',
  INVALID_CHAIN_STORE = '対象レシート以外',
  NO_DATE_TIME = '日付判読NG',
  INVALID_DATE_TIME = '日付有効期間外',
  NO_TARGET_CATEGORY_ITEM = '対象カテゴリ商品なし',
  UNKNOWN_ITEM = '判読不明商品あり',
  NO_SUM = '合計金額判読NG',
  ILLEGAL_RECEIPT = 'レシート不正加工あり',
  OTHER = 'その他',
}

export enum Payment {
  CACHE = '現金決済',
  CREDIT = 'クレジットカード決済（Visa、Master、JCB他）',
  DISTRIBUTION = '流通系電子マネー・タッチ式決済（WAON、nanaco、楽天Edy他）',
  TRAFFIC = '交通系電子マネー・タッチ式決済（Suica、PASMO他）',
  PAYPAY = 'QR決済（Pay Pay）',
  RAKUTENPAY = 'QR決済（楽天Pay）',
  LINEPAY = 'QR決済（LINE Pay）',
  MERPAY = 'QR決済（メルペイ）',
  FAMIPAY = 'QR決済（FamiPay）',
  AUPAY = 'QR決済（auPay）',
  QR = 'QR決済（その他）',
  ID = '電子決済（iD）',
  QUICKPAY = '電子決済（Quick Pay）',
  D = '電子決済（d払い）',
  ELECTRONIC = '電子決済（その他）',
  COOPERATE = '企業独自のポイントカード・電子マネー決済（ WAON、nanaco 以外）',
  COMMON = '共通ポイント決済（Tポイント、Ponta、楽天スーパーポイント、dポイント）',
  DEBIT = 'デビットカード決済',
  COUPON = '全額クーポン・商品券利用',
  OTHER = 'その他',
}

export enum Point {
  PONTA = 'Ponta',
  T = 'Tポイント',
  RAKUTEN = '楽天ポイント',
  D = 'dポイント',
  NANACO = 'nanaco',
  WAON = 'WAON',
  OTHER = '上記以外のその他のポイント',
  NONE = 'ポイントは貯めていない',
}

export enum ReceiptSupplier {
  WED = 'wed',
  RAKUTEN = 'rakuten',
  RECEIPO = 'receipo',
  AQFPOB = 'aqfpob',
  PONTA = 'ponta',
  TENTAME = 'tentame',
  LOCARI = 'locari',
  CHOBIRICH = 'chobirich',
}

const questionnaireOnlySuppliers = [ReceiptSupplier.LOCARI]

export const receiptSuppliers = Object.values(ReceiptSupplier).map(value => {
  let text = ''
  switch (value) {
    case ReceiptSupplier.WED:
      text = 'WED'
      break
    case ReceiptSupplier.RAKUTEN:
      text = '楽天'
      break
    case ReceiptSupplier.RECEIPO:
      text = 'レシーポ'
      break
    case ReceiptSupplier.AQFPOB:
      text = '貯める'
      break
    case ReceiptSupplier.PONTA:
      text = 'ポンタ'
      break
    case ReceiptSupplier.TENTAME:
      text = 'テンタメ'
      break
    case ReceiptSupplier.LOCARI:
      text = 'URL'
      break
    case ReceiptSupplier.CHOBIRICH:
      text = 'ちょびリッチ'
      break
    default:
      break
  }
  return {
    text,
    value,
  }
})

export const supplierName = (supplier: ReceiptSupplier): string => {
  switch (supplier) {
    case ReceiptSupplier.WED:
      return 'WED'
    case ReceiptSupplier.RAKUTEN:
      return '楽天'
    case ReceiptSupplier.RECEIPO:
      return 'レシーポ'
    case ReceiptSupplier.PONTA:
      return 'ポンタ'
    case ReceiptSupplier.AQFPOB:
      return '貯める'
    case ReceiptSupplier.TENTAME:
      return 'テンタメ'
    case ReceiptSupplier.LOCARI:
      return 'URL'
    case ReceiptSupplier.CHOBIRICH:
      return 'ちょびリッチ'
    default:
      return ''
  }
}

export const isQuestionnaireOnly = (supplier: ReceiptSupplier) => {
  return questionnaireOnlySuppliers.includes(supplier)
}

export const isQuestionnaireOnlyName = (supplier: string) => {
  return questionnaireOnlySuppliers.map(supplierName).includes(supplier)
}

export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
  OTHER = 'other',
}

export const genders = Object.values(Gender).map(value => {
  return {
    text:
      value === Gender.MALE
        ? '男性'
        : value === Gender.FEMALE
        ? '女性'
        : 'その他',
    value,
  }
})

export type SearchCondition = {
  supplier: string | null
  monitorId: string | null
  receiptId: number | null
  contributedAtStart: string | null
  contributedAtEnd: string | null
  gender: 0 | 1 | null
  prefecture: string | null
  age: number | null
  chainStoreName: string | null
  purchasedAtStart: string | null
  purchasedAtEnd: string | null
  ngReason: string | null
}

export interface IReceipt {
  id: number
  createdAt: Date
  updatedAt: Date
  deletedAt: Date | null
  imageId: string
  supplier: ReceiptSupplier
  importedAt: Date
  postedAt: Date | null
  ocr: string
  monitorId: string
  monitorGender: Gender
  monitorBirthday: string | null
  monitorAge: number | null
  monitorZipcode: string | null
  monitorPrefecture: string | null
  monitorIsMarried: boolean | null
  monitorPlaceName: string | null
  regiNumber: string | null
  phone: string | null
  shopId: number | null
  shop: IShop | null
  chainStoreId: number | null
  chainStore: IChainStore | null
  channelId: number | null
  channel: IChannel | null
  dateTime: Date | null
  sum: number | null
  paymentOcr: string | null
  payment: Payment | null
  pointOcr: string | null
  point: Point | null
  imageUrl: string // added by helper
  originalImageUrl: string // added by helper
  // ngReasons: NgReason[]
  ngReason: NgReason | null
  otherNgReason: string
  needReProcess: boolean
  isAutoCompleted: boolean
  systemOkedAt: Date | null
  linkerOkedAt: Date | null
  leaderOkedAt: Date | null
  systemNgedAt: Date | null
  linkerNgedAt: Date | null
  leaderNgedAt: Date | null
  okedByLinkerId: number | null
  // okedByLinker: IUser | null
  okedByLeaderId: number | null
  // okedByLeader: IUser | null
  ngedByLinkerId: number | null
  // ngedByLinker: IUser | null
  ngedByLeaderId: number | null
  // ngedByLeader: IUser | null
  duplicatedId: number | null
  closedAt: Date | null
  items: IItem[]
}

export interface IItem {
  id: number
  createdAt: Date
  updatedAt: Date
  deletedAt: Date | null
  ocr: string
  name: string | null
  category: string | null
  price: number | null
  quantity: number | null
  matchedName: string | null
  matchedCode: string | null
  autoMatchedAt: Date | null
  isFinallyAutoMatched: boolean
  isMatched: boolean
  newMatchOkedAt: Date | null
  reMatchedAt: Date | null
  reMatchOkedAt: Date | null
  receiptId: number
  receipt: IReceipt | null
  createdByUserId: number | null
  // createdByUser: IUser | null
  updatedByUserId: number | null
  // updatedByUser: IUser | null

  originalMatchedCode: string | null
  isChanged: boolean
}

export interface ISummary {
  thisMonth: number
  lastMonth: number
  today: number
  yesterday: number
  now: number
  thisMonthFirst: number
  lastMonthFirst: number
  todayFirst: number
  yesterdayFirst: number
}

export interface ISummaries {
  contributerUU: ISummary
  inComing: ISummary
  duplicated: ISummary
  system: {
    ok: ISummary
    autoCompleted: ISummary
    noPhone: ISummary
    noShop: ISummary
    invalidChainStore: ISummary
    noDateTime: ISummary
    invalidDateTime: ISummary
    noTargetCategoryItem: ISummary
  }
  leaderForSystemNg: {
    incompleted: ISummary
    shopApplying: ISummary
    ok: ISummary
    ng: ISummary
  }
  linker: {
    incompleted: ISummary
    wip: ISummary
    ok: ISummary
    ng: ISummary
  }
  leaderForLinkerNg: {
    incompleted: ISummary
    ok: ISummary
    ng: ISummary
  }
  completed: ISummary
  completedItem: ISummary
  autocompletedItem: ISummary
  newItem: ISummary
  reItem: ISummary
  linkerUU: ISummary
  leaderUU: ISummary
}
